import { Model } from 'modules/core/lib/mobx-rest'

import type { ITemplateVariable } from './Variable'

class CustomFieldVariable extends Model<ITemplateVariable> {
  static urlRoot() {
    return '/custom_field_variables'
  }
}

export default CustomFieldVariable
